import{m as n}from"./chunk-HBP5N4FR.js";n();var t=!1;function s(e){t||(console.error(e),t=!0)}function c({explorerAddress:e,to:r}){try{return new URL(r).href}catch(i){return r.startsWith("/")||(s(`Link not prepended by / : ${r}`),r=`/${r}`),e?`${e}${r}`:r}}export{c as a};
//# sourceMappingURL=chunk-NCHDT5N7.js.map
